/**
 * HintEmptyObjectNameValidator class is responsible for validating if the object name in the model is empty.
 * It uses Angular's $translate service to handle translations of error messages.
 */
class HintEmptyObjectNameValidator {
    /**
     * Constructs a new instance of HintEmptyObjectNameValidator.
     * @param {Object} $injector - The AngularJS injector service.
     * @param {Object} model - The model object containing the data to be validated.
     */
    constructor($injector, model) {
        this.$injector = $injector;
        this.model = model;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.EMPTY.HINT-OBJECT-NAME';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Lazily initializes and returns the $translate service.
     * @returns {Object} The $translate service.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model to check if the object name is empty.
     * @param {Object} from - The source object from which the validation is triggered.
     * @returns {Object} The result of the validation.
     */
    validate(from) {
        let result = {};
        let error = false;

        // Check if the model has a getObjectType method and if the object type is 'hint'
        if (typeof this.model.getObjectType === 'function' && this.model.getObjectType() === 'hint') {
            let preferences;
            // Determine how to retrieve preferences based on the existence of getPreferences method
            if (typeof this.model.getPreferences === 'function') {
                preferences = this.model.getPreferences();
            } else {
                preferences = this.model.preferences;
            }
            // Check if the object name in preferences is empty
            if (!preferences.objName) {
                error = true;
            }
        }

        result = {
            'onSheetBlur': false,
            'onlyBanner': false,
            'validator': this.getValidatorName(),
            'modelUUID': this.model.getUUID(),
            'error': error,
            'status': error ? 'DANGER' : 'SUCCESS', // WARNING | DANGER | SUCCESS
            'message': this.getErrorMessage(),
            'message_template': false,
            'callbacks': [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };

        return result;
    }

    /**
     * Returns the error message for an empty object name.
     * @returns {string} The translated error message.
     */
    getErrorMessage() {
        let questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate.instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Returns the status of the forced check.
     * @returns {boolean} The status of the forced check.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Returns the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'HintEmptyObjectNameValidator';
    }
}

export default HintEmptyObjectNameValidator;